export default __webpack_public_path__ + "static/media/PdfIcon.0dff2bc7.svg";